package ru.it_mozaika.sender.js.application.components.properties

import mui.icons.material.Cancel
import mui.material.*
import mui.system.responsive
import mui.system.sx
import react.*
import ru.it_mozaika.sender.common.models.Property
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.FlexWrap
import web.cssom.px

external interface PropertiesDeleteDialogProps: Props {
    var selected: List<Property>
    var onClose: () -> Unit
    var isOpen: Boolean
}

val propertiesDeleteDialog = FC<PropertiesDeleteDialogProps> { props ->
    val (selected, setSelected) = useState<List<Property>>(listOf())
    val requestResult = useContext(RequestResultContext)
    useEffect(props.selected) {
        setSelected(props.selected)
    }
    Dialog {
        this.open = props.isOpen
        DialogTitle {
            +"Вы уверены что хотите далить данные свойства? Данное действие невозможно отменить."
        }
        DialogContent {
            FormControl {
                sx {
                    margin = 5.px
                    minWidth = 200.px
                }
                fullWidth = true
                InputLabel {
                    id = "properties-delete-select-label"
                    +"Свойства"
                }
                Select {
                    labelId = "properties-delete-select-label"
                    id = "properties-delete-select"
                    value = selected.toTypedArray()
                    label = ReactNode("Свойства:")
                    multiple = true
                    onChange = onChange@{ e, _ ->
                        val ids = e.target.value.unsafeCast<Array<String>>()
                        val newList = ids.mapNotNull { id ->
                            props.selected.find { it.id == id }
                        }
                        setSelected(newList)
                    }
                    renderValue = useMemo(selected) {
                        { _ ->
                            Box.create {
                                sx {
                                    display = Display.flex
                                    flexWrap = FlexWrap.wrap
                                    asDynamic().gap = 0.5
                                }
                                selected.forEach { property ->
                                    Chip {
                                        deleteIcon = Cancel.create {
                                            onMouseDown = {
                                                it.stopPropagation()
                                            }
                                        }
                                        onDelete = {
                                            setSelected {
                                                it.minus(property)
                                            }
                                        }
                                        key = property.id
                                        label = ReactNode(property.name)
                                    }
                                }
                            }
                        }
                    }
                    props.selected.forEach { property ->
                        MenuItem {
                            this.selected = selected.contains(property)
                            value = property.id
                            +property.name
                        }
                    }
                }
            }
        }
        DialogActions {
            sx {
                alignItems = AlignItems.flexEnd
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.outlined
                    disabled = selected.isEmpty()
                    color = ButtonColor.secondary
                    +"Удалить"
                    onClick = {
                        Http.post("/subscribers/properties/delete", body = selected.map{it.id}) { response ->
                            requestResult.handleRequestRespond(response)
                            props.onClose()
                        }
                    }
                }
                Button {
                    variant = ButtonVariant.outlined
                    +"Отмена"
                    color = ButtonColor.error
                    onClick = {
                        props.onClose()
                    }
                }
            }
        }
    }
}